
import React from "react";
import DataTable from "react-data-table-component";
import { careFacilityUserAuditColumns, careFacilityUserAuditExcelColumns } from "./careFacilityUserAuditColumns";
import { useState, useEffect } from "react";
import {
  IconButton,
  TextField,
  InputAdornment,
  Box,
  MenuItem,
  Select,
  FormControl,
  Button,
  Grid,
  Divider
} from "@mui/material";
import "../../listings/Listing.css";
import { Search } from "@mui/icons-material";
import {
  getClientUserLogs,
} from "../../common/constants/globalconstants";
import CircularProgress from "@mui/material/CircularProgress";
import Backdrop from "@mui/material/Backdrop";
import { useSelector } from "react-redux";
import { CustomExcelExport } from "../../common/CustomExcelExport";
import ErrorModal from "../../common/ErrorModal";
import AuditDataCompareModal from "../../common/AuditDataCompareModal";
import { DatePicker } from "@mui/x-date-pickers";
import dayjs from "dayjs";
import axiosInstance from "../../common/AxiosInterceptor";

const customStyle = {
	table: {
	  style: {
		border: "1px solid #DEDEDE",
		borderRadius: "5px",
		justifyContent: "center",
		marginBottom: "10px",
		marginTop: "10px",
	  },
	},
	header: {
	  style: {
		color: "#193062",
	  },
	},
	headRow: {
	  style: {
		border: "none",
		backgroundColor: "#CDD4DC",
		fontWeight: "bold",
		color: "#002d82",
		fontSize: "14px",
		whiteSpace: "unset",
	  },
	},
	rows: {
	  stripedStyle: {
		backgroundColor: "#F2F3F5",
		justifyContent: "center",
	  },
	},
  };

function CareFacilityUserAudit() {
  const [tableData, setTableData] = useState([]);
  const [originalData, setOriginalData] = useState([]);
  const [tableKey, setTableKey] = useState(0);
  const [loading, setloading] = useState(false); 
  const [clientUserAuditData, setClientUserAuditData]= useState([]);
  const [errormodalopen, seterrormodalOpen]= useState(false);
  const [openModal, setOpenModal]= useState(false);
  const [rowData, setRowData]= useState({});
  const [isErr, setIsErr] =useState(false);
  const [frmDtErr, setFrmDtErr] = useState("");
  const [fromDate, setFromDate] =useState("");
  const [toDate, setToDate] =useState("");
  const [action, setAction] =useState('');
  const [searchField, setSearchField] =useState("");
  const [searching, setSearching] =useState(false);
  const [resetPagination, setRstPagination] = useState(false);
  const storeuser = useSelector((state) => state.storeuser);

  useEffect(()=>{
    getClientUserAuditLogs();  
  },[]);

   const getFormattedDate =(inputDate)=>{
    const date =new Date(inputDate);
    const month = String(date.getUTCMonth()+1).padStart(2, '0');
    const day = String(date.getUTCDate()).padStart(2, '0');
    const year = date.getUTCFullYear();
   
    return `${month}-${day}-${year}`;
  }

  const createInputRequest=()=>{
    return {
      "fromDate": fromDate ? getFormattedDate(fromDate): "",
      "toDate": toDate ? getFormattedDate(toDate): "",
      "action": action ? action: ""
    }
  }

  const getClientUserAuditLogs = () =>{
    const inputRequest= createInputRequest();   
    getApiResponse(inputRequest);
  }

  const getApiResponse =async(inputRequest)=>{
    try {
      setloading(true);
      const response = await axiosInstance.post(`${getClientUserLogs}`,
               JSON.stringify(inputRequest));
	
        if(response.data.isSuccess){
		   setClientUserAuditData(response.data.result);
           setTableData(response.data.result);
		   setOriginalData(response.data.result);
		   setTableKey(prevKey=> prevKey+1);
           seterrormodalOpen(false);
        }
        else if(!response.data.isSuccess){
          seterrormodalOpen(true);
        }
        setloading(false);
    } catch (error) {
      console.log(error.message);
      seterrormodalOpen(true);
      setloading(false);
    }
  }

  const handleChangeInput = (e) => {
	setRstPagination(!resetPagination);
	setSearching(true);
	setSearchField(e.target.value);
    let searchValue = false;
    let id = false;
    let keyId = false;
    let oldValues = false;
    let newValues = false;
    let updatedBY = false;
    let updatedAt = false;
    let action = false;

    const newdata = tableData && tableData.filter((row) => {
      id = row.id && row.id.toString().includes(e.target.value.toString());
      keyId = row.keyId && row.keyId.toString().includes(e.target.value.toString());
      oldValues = row.oldValues && row.oldValues.toLowerCase().includes(e.target.value.toLowerCase());
      newValues = row.newValues && row.newValues.toLowerCase().includes(e.target.value.toLowerCase());
      updatedBY = row.updatedBY && row.updatedBY.toString().toLowerCase().includes(e.target.value.toString().toLowerCase());
      updatedAt = row.updatedAt && row.updatedAt.toString().includes(e.target.value.toString());
      action = row.action && row.action.toString().toLowerCase().includes(e.target.value.toString().toLowerCase());

      if (id) {
        searchValue = id;
      } 
      else if (keyId) {
        searchValue = keyId;
      } 
      else if (oldValues) {
        searchValue = oldValues;
      } 
      else if (newValues) {
        searchValue = newValues;
      } 
      else if (updatedBY) {
        searchValue = updatedBY;
      }
      else if (updatedAt) {
        searchValue = updatedAt;
      }
      else {
        searchValue = action;
      }
      return searchValue;
    });
    setClientUserAuditData(newdata);
  };

  const handleChange=(e)=>{
    setAction(e.target.value);
  }

  const handleClose =()=>{
    setOpenModal(false);
  }

  const handleRowClick = (row) => {
    setRowData(row);
    setOpenModal(true);    
  };

  const validateRequest =() =>{
    let isError=false;
      if(toDate !=="" && toDate!==undefined && toDate!==null && (fromDate === "" || fromDate===undefined || fromDate===null)){
        setFrmDtErr("From Date can not be blank");
        setIsErr(true);
        isError =true;
      }
	  else if(fromDate!=="" && toDate!=="" && fromDate> toDate){
		setFrmDtErr("From Date should be less than To Date");
		setIsErr(true); 
        isError =true;
	  }
	  else{
        setFrmDtErr("");
        setIsErr(false);
        isError =false;
      }
    return isError;
  }

  const handleSearchClick=()=>{  
	setRstPagination(!resetPagination);
	setSearching(false);
    const err=validateRequest();
    if(!err){      
      getClientUserAuditLogs();
	  setSearchField("");
    }    
  }

  const handleResetClick=()=>{
    setFromDate("");
      setToDate("");
      setAction("");
      setIsErr("");
	  setSearchField("");
	  setRstPagination(!resetPagination);
      const inputRequest= {
        "userName": storeuser.email ? storeuser.email : "",
        "fromDate": "",
        "toDate": "",
        "action": ""
      }  
      getApiResponse(inputRequest);
	  setClientUserAuditData(originalData);
	  setTableKey(prevKey=> prevKey+1);
  }

	  return (
		<div>
		  {loading && (
			<>
			  <Backdrop
				sx={{ color: "white", zIndex: (theme) => theme.zIndex.drawer + 1 }}
				open={true}
			  >
				<CircularProgress sx={{ color: "white" }} />
				<span> &nbsp;&nbsp;&nbsp;&nbsp; Loading Data... </span>
			  </Backdrop>
			</>
		  )}
	
		<div>
		  <Box
        sx={{
          position: "relative",
          alignContent:"center",
          justifyContent: "center",
          left: "1%",
		  right: "2%",
          flexDirection: "column",
          width: "97%",
          marginTop: "10px",
          marginBottom: "10px",
          alignItems: "center",
          p: "0% 1%",
          backgroundColor: "#fcfcfc",
          //border: "2px solid #dfe3e8",
          borderRadius: "20px",
        }}
      >
		  <h2 className="header">Care Facility User Audit Logs</h2>
		   
		  <Box
		  sx={{
			justifyContent:"center",
			alignContent:"center",
			alignItems:"center",
			display:"flex",
			width:"100%",
			height:"20px"
		  }}>
		  <p style={{color:"red", marginTop:"4px"}}>{isErr && frmDtErr? frmDtErr:""}</p>
		  </Box>
			<div
			  style={{
				display: "flex",
				flexDirection: "row",
				//marginBottom: "1rem",
				//marginTop: "1rem",
				//padding: "8px",
			  }}
			>  
		  <Grid container> 
		  <div style={{marginTop: "5px", width:"98%", marginRight:"10px"}}>              
				  <Box
				  sx={{
					border:"1px solid #002d82",
					position:"relative",
					display:"inline-block",
					barderRadius:"5px",
					width: "100%",
					padding:"8px",
					marginRight:"8px"
				  }}>
					 <Box
					  display="flex"
					  direction="row"
					  alignItems="left"
					  justifyContent="left"
					  alignContent="left"
					  columnGap="0.5rem"
					  sx={{ width:"100%", height: "50px", m: "3px 0", marginTop:"5px" }} 
				  >
				<Grid xs={3}>
				  <Box
					display="flex"
					sx={{
					  flexDirection: "row",
					  alignItems: "center",
					  justifyContent: "center",
					  alignContent: "center",
					  height: "50px",
					  fontSize: "15px"
					}}
				  > 
				   <p style={{width: "80px", color: "black",fontWeight: "600", marginLeft:"5px"}}>
					Action:</p>
				 
				 <FormControl variant="outlined" fullWidth margin="normal" size='small' style={{width:"180px", marginBottom:"20px", marginRight:"5px"}}>
								<Select							
								name="action"
								value={action}
								onChange={handleChange}
								displayEmpty
								>
								<MenuItem value="">
								<em>------- Select -------</em>
								</MenuItem>   
								<MenuItem value="ADD">ADD</MenuItem>
								<MenuItem value="UPDATE">UPDATE</MenuItem>
								<MenuItem value="DELETE">DELETE</MenuItem>
								</Select>                    
						</FormControl>
				 </Box>
				 </Grid>
				 <Grid xs={3}>
				  <Box
					display="flex"
					sx={{
					  flexDirection: "row",
					  alignItems: "center",
					  justifyContent: "center",
					  alignContent: "center",
					  height: "50px",
					  fontSize: "15px"
					}}
				  > 
				  
					<p style={{width: "100px", color: "black",fontWeight: "600", marginLeft:"5px"}}>
					From Date:</p>
				  <DatePicker
				  className="report-to-datePicker"
				  sx={{ ml: "0px", width: "180px", marginBottom:"30px", marginRight:"10px", "& .MuiInputBase-input":{ height: "7px !important"} }}
				  inputFormat="MM DD YYYY"
				  slotProps={{
					textField:{
						error:false
					}
				  }}
				  name="fromDate"
				  onChange={(newValue)=> 
					setFromDate(newValue)
				  }
				  value={dayjs(fromDate)}
				  size="small"
				  >               
				  </DatePicker>
				  
				 </Box>
				 </Grid>
				 <Grid xs={3}>
				  <Box
					display="flex"
					sx={{
					  flexDirection: "row",
					  alignItems: "center",
					  justifyContent: "center",
					  alignContent: "center",
					  height: "50px",
					  fontSize: "15px"
	  
					}}
				  > 
				  <p style={{width: "80px", color: "black",fontWeight: "600"}}>
							To Date:</p>
							<DatePicker
							className="report-to-datePicker"
							sx={{ ml: "0px", width: "180px", marginBottom:"30px", marginRight:"10px", "& .MuiInputBase-input":{ height: "7px !important"} }}
							inputFormat="MM DD YYYY"
							slotProps={{
								textField:{
									error:false
								}
							  }}
							name="toDate"
							onChange={(newValue)=> 
							setToDate(newValue)
							}
							value={dayjs(toDate)}
							size="small"
							>
							</DatePicker>
				  
				  </Box> 
				  </Grid>
				  <Grid xs={3}>
				  <Box
					display="flex"
					sx={{
					  flexDirection: "row",
					  alignItems: "center",
					  justifyContent: "center",
					  alignContent: "center",
					  height: "50px",
					  fontSize: "15px",
					  columnGap: "1rem"
					}}
				  > 
				  <Button
					variant="contained"
					style={{ backgroundColor:"#002d82",width: "110px", height:"35px", marginBottom:"6px", marginLeft: "0.5rem"}}
					onClick={handleSearchClick}
					>
					Search
					</Button>
			
					<Button
					variant="contained"
					style={{ backgroundColor:"#002d82",width: "110px", height:"35px", marginBottom:"6px"}}
					onClick={handleResetClick}
					>
					Reset
					  </Button> 
				  
				  </Box> 
				  </Grid>
				  </Box> 
					  
				  <Box
				  component="span"
				  sx={{ 
					position: "absolute",
					top: "-12px",
					left:"15px",
					//transform:"translateX(-50%)",
					backgroundColor: "white",
					padding: "0 10px",
					fontSize:"14px",
					whiteSpace:"nowrap"
					}}
					  >
					   Filter Criteria:   
							
				  </Box>
				  </Box>
		  </div>
		  </Grid>    
		  </div> 
		  
		
		<Box sx={{display:"flex", flexDirection:"row", width:"100%", height:"55px", alignItems:"center"}}>
		  <Box sx={{width:"50%", alignContent:"left", float:"left", justifyContent:"left",textAlign:"left"}}>
			<div style={{alignContent:"left", marginTop:"10px"}}>
			{clientUserAuditData && clientUserAuditData.length>0? 
				<CustomExcelExport
				filename={`ClientUserAudit.xlsx`}
				data={clientUserAuditData}
				headers={careFacilityUserAuditExcelColumns}
				type={"align-left"}
				>
			</CustomExcelExport>
			  :null}
			</div>
			</Box>
			<Box sx={{width:"50%", alignContent:"right", float:"right", justifyContent:"right"}}>
				<div style={{alignContent:"right", textAlign:"right"}}>
				{(clientUserAuditData && clientUserAuditData.length >0) || searching ?
				<TextField
				  placeholder="Search"
				  type="text"
				  variant="outlined"
				  margin="normal"
				  value={searchField}
				  onChange={handleChangeInput}
				  InputProps={{
					endAdornment: (
					  <InputAdornment position="end">
						<IconButton>
						  <Search />
						</IconButton>
					  </InputAdornment>
					),
					sx: { borderRadius: "5px", height: "40px", textAlign:"center" },
				  }}
				/>
			  : null}
				</div>
			</Box>		 
         </Box>

			<DataTable
			  title=""
			  key={tableKey}
			  columns={careFacilityUserAuditColumns}
			  data={clientUserAuditData}
			  pagination
			  striped
			  highlightOnHover
			  customStyles={customStyle}
			  defaultSortFieldId={null}
			  defaultSortAsc={null}
			  paginationRowsPerPageOptions={[5, 10, 15, 20]}
			  paginationPerPage={5}
			  paginationComponentOptions={{
				rowsPerPageText: "Records per page",
				rangeSeparatorText: "Out of",
			  }}
			  onRowClicked={handleRowClick}
			  paginationResetDefaultPage={resetPagination}
			/>
			
			</Box>
		  </div>
		  {errormodalopen && (
			<ErrorModal open={true} onClose={() => seterrormodalOpen(false)} />
		  )}
	
		  {openModal && (
			<AuditDataCompareModal open={openModal} plzclose={handleClose} rowData={rowData}/>
		  )}
		</div>
	  );
}

export default CareFacilityUserAudit;
